var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualityOfLife(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 4.16663C52.3013 4.16663 54.1667 6.03213 54.1667 8.33329V25C54.1667 27.3011 52.3013 29.1666 50 29.1666C47.6988 29.1666 45.8334 27.3011 45.8334 25V8.33329C45.8334 6.03213 47.6988 4.16663 50 4.16663Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 70.8334C52.3013 70.8334 54.1667 72.6988 54.1667 75V91.6667C54.1667 93.968 52.3013 95.8334 50 95.8334C47.6988 95.8334 45.8334 93.968 45.8334 91.6667V75C45.8334 72.6988 47.6988 70.8334 50 70.8334Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5954 17.5954C19.2226 15.9682 21.8608 15.9682 23.4879 17.5954L35.2796 29.3871C36.9068 31.0142 36.9068 33.6525 35.2796 35.2796C33.6525 36.9068 31.0142 36.9068 29.3871 35.2796L17.5954 23.4879C15.9682 21.8608 15.9682 19.2226 17.5954 17.5954Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7204 64.7204C66.3475 63.0934 68.9859 63.0934 70.6129 64.7204L82.4046 76.5121C84.0317 78.1392 84.0317 80.7775 82.4046 82.4046C80.7775 84.0317 78.1392 84.0317 76.5121 82.4046L64.7204 70.6129C63.0934 68.9859 63.0934 66.3475 64.7204 64.7204Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16663 50C4.16663 47.6988 6.03213 45.8334 8.33329 45.8334H25C27.3011 45.8334 29.1666 47.6988 29.1666 50C29.1666 52.3013 27.3011 54.1667 25 54.1667H8.33329C6.03213 54.1667 4.16663 52.3013 4.16663 50Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8334 50C70.8334 47.6988 72.6988 45.8334 75 45.8334H91.6667C93.968 45.8334 95.8334 47.6988 95.8334 50C95.8334 52.3013 93.968 54.1667 91.6667 54.1667H75C72.6988 54.1667 70.8334 52.3013 70.8334 50Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2796 64.7204C36.9068 66.3475 36.9068 68.9859 35.2796 70.6129L23.4879 82.4046C21.8608 84.0317 19.2226 84.0317 17.5954 82.4046C15.9682 80.7775 15.9682 78.1392 17.5954 76.5121L29.3871 64.7204C31.0142 63.0934 33.6525 63.0934 35.2796 64.7204Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4046 17.5954C84.0317 19.2226 84.0317 21.8608 82.4046 23.4879L70.6129 35.2796C68.9859 36.9068 66.3475 36.9068 64.7204 35.2796C63.0934 33.6525 63.0934 31.0142 64.7204 29.3871L76.5121 17.5954C78.1392 15.9682 80.7775 15.9682 82.4046 17.5954Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityOfLife);
export default __webpack_public_path__ + "static/media/qualityOfLife.ecc42b1d6c7de0d7c72879dab93d2047.svg";
export { ForwardRef as ReactComponent };